'use strict';

export default function($stateProvider) {
  'ngInject';

  $stateProvider
    .state('news-archive', {
      url: '/news/archive',
      template: '<news-archive></news-archive>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/news/archive/news-archive.routes.js